import { ZodShape } from '@client/new/helpers/types';
import { UpdateVideoInput, ContentAccessMethod } from 'generated/graphql';
import { commonUpdateShape } from '../pdf/pdf.schema';
import { z } from 'zod';
import { createStringValidator, optionalUrlValidator } from '../pdf/zod.utils';

const maxTitleLength = 500;
const minContentLength = 1;

const validString = (minLength: number, maxLength: number, fieldName: string) =>
  z
    .string()
    .trim()
    .min(minLength, `${fieldName} is required`)
    .max(maxLength, `${fieldName} too long`);

const createVideoInputShape: ZodShape<UpdateVideoInput> = {
  ...commonUpdateShape,

  title: createStringValidator(minContentLength, maxTitleLength, 'Video title'),
  coverURL: optionalUrlValidator.nullable(),
  description: z
    .string()
    .trim()
    .max(2000, 'Description cannot exceed 2000 characters')
    .nullable()
    .optional()
    .or(z.literal('').transform(() => null)),
  allowComments: z.boolean(),
  libraryVideoId: validString(1, 255, 'Mux Asset ID'),

  thumbnailCustomURL: optionalUrlValidator.nullable(),
  thumbnailTimestampMs: z
    .number()
    .min(0, 'Thumbnail timestamp must be non-negative'),
  isProcessed: z.boolean().optional().default(false),
  downloadable: z.boolean().optional().default(false),
  accessMethod: z.nativeEnum(ContentAccessMethod).optional(),
  isArchived: z.boolean().optional(),
};

export const videoValidationSchema = z
  .object({
    ...createVideoInputShape,
  })
  .passthrough();
